import React from "react";
import Box from "@mui/material/Box";
import {
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";

export const CustomToolbar = () => {
  return (
    <Box
      sx={{
        p: 1,
        display: "flex",
        justifyContent: "flex-start",
      }}
    >
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
    </Box>
  );
};
